import { Pipe, PipeTransform } from '@angular/core';

import { ProductMeta } from '@proto/store/api/common/common';
import { Links } from '@helper/links';
import { Urls } from '@helper/urls';
import { Skus } from '@helper/skus';
import { environment } from '../../../environments/environment';

@Pipe({ name: 'linkToUrl', standalone: true })
export class LinkToUrl implements PipeTransform {
  transform(
    meta: ProductMeta | undefined,
    link: string | undefined,
    openNewWindow = false,
    skuId: string | undefined = undefined
  ): [string | null, boolean] {
    if (!meta && !link) {
      return [null, false];
    }
    const sku = skuId ? Skus.fromId(skuId) : undefined;
    const url = (skuId ? Urls.fromSkuId(skuId) : Urls.fromMeta(meta, sku?.colorId)) || Links.extractUrl(link);
    if (url?.startsWith('http')) {
      return [url, true];
    }
    if (openNewWindow && url) {
      return [`${environment.endPointUrl}${Links.appendLocale(url)}`, true];
    }
    return [url, false];
  }
}
